<header>
  <section navigation>
    <nav>
      <ac-icon class="lg:!hidden pointer" name="menu" size="big" (click)="menuTrigger.emit()" />
      <ac-home-logo />
      <ac-nav-links class="hidden lg:block" />
    </nav>

    <section class="client-info">
      @if (_shouldRenderLangSelection) {
        <ac-lang-selection />
      }
      <ac-help-trigger />
      <ac-profile-trigger />
    </section>
  </section>
  @if (_authUserSig()) {
    <section>
      <ac-notifications-trigger />
    </section>
  }
</header>
